import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ZoneVisitsStatistics } from 'src/features/statistic/types';

const RESOURCE = 'sp-core/:parkingId/stats/zone-visits/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
    active_as_of_after?: string;
    active_as_of_before?: string;
    zone?: string;
}

const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<ZoneVisitsStatistics>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_ZONE_VISITS_RESOURCE, useQueryHook as useListZoneVisits };
